import { connect } from 'react-redux';
import DataSinkCard from './DataSinkCard';
import has from 'lodash/has';
import { isReadOnly, isManagedResource, isAdminAccess } from 'js/lib/ACLUtils';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';
import { RESOURCE_TYPE_SINK } from 'js/constants/resourceTypes';

const mapStateToProps = (state, ownProps) => {
  const {
    request,
    entities: { users, vendors, flowNodes, credentials },
    paging: { metaInfoById },
    metrics,
  } = state;
  const { cardData } = ownProps;
  const metric = has(metrics[RESOURCE_TYPE_SINK], cardData.id)
    ? metrics[RESOURCE_TYPE_SINK][cardData.id]
    : null;
  const data = cardData;

  const flow = flowNodes[data.origin_node_id];
  const flowType = data?.flow_type || flow?.flow_type;

  const connectionOrVendorType = getConnectionOrVendorType(data, vendors, 'sink_type', 'vendor_id');
  const connectionInfo =
    metaInfoById && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : null;
  // const errorCount = has(data_sinks, `${data.id}.fileStats.numErrorFiles`)
  //   ? data_sinks[data.id].fileStats.numErrorFiles
  //   : 0;
  const readOnly = isReadOnly(data);
  const isManaged = isManagedResource(data);
  const adminAccess = isAdminAccess(data);

  let owner = null;
  if (has(data, 'owner_id') && has(users, data.owner_id)) {
    owner = users[data.owner_id];
  } else if (has(data, 'owner') && has(users, data.owner)) {
    owner = users[data.owner];
  }

  return {
    flowType,
    connectionInfo,
    credentials,
    connectionOrVendorType,
    data,
    readOnly,
    adminAccess,
    isManaged,
    owner,
    metric,
    isLoading: {
      metric: request.GET_FLOW_METRICS_REQUEST || false,
    },
  };
};

export default connect(mapStateToProps)(DataSinkCard);
